import styled from '@emotion/styled';
import { form, input } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { mediaQuery } from 'src/assets/media-query-config';
import { ArrowUpIcon } from 'src/assets/icons/ArrowUpIcon';
import { ScrollBarVertical } from 'src/domains/layouts/shared/scrollbar/Scrollbar.style';
import { InputRow } from 'src/domains/layouts/shared/formComponents/input/Input.style';

export const FormComponent = styled('form', { label: 'FormComponent' })`
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    margin-top: 32px;
`;

const cmsFormContainerHeight = 'calc(100vh - 104px)';

interface FormWrapperPropsType {
    isEditMode?: boolean;
}

export const FormWrapper = styled(ScrollBarVertical, { label: 'FormWrapper' })<FormWrapperPropsType>`
    background: ${({ isEditMode }): string => isEditMode === true ? form.bgColorSecondary : form.bgColor};
    padding: 16px 16px 24px;

    @media ${mediaQuery.xLargeDesktop} {
        min-height: 400px;
        max-height: ${cmsFormContainerHeight};
    }
`;

interface DatePickerPropsType {
    isError?: boolean;
    isEmpty?: boolean;
}

export const DatesWrapper = styled(InputRow, { label: 'DatesWrapper' })`
    margin-bottom: 16px;

    .react-datepicker-wrapper {
        width: 100%;
        border: none;
    }
    .react-datepicker__input-container {
        input {
            width: 100%;
            background-color: ${input.bgColor};
            flex: 0 0 40px;
            font-family: var(--fontFamilyPrimary);
            font-size: ${fontSize.xRegular};
            font-weight: ${fontWeight.medium};
            height: 40px;
            line-height: 1.4;
            outline: none;
            padding: 10px 12px;
        }
    }
`;

export const DateInputWrapper = styled('div', { label: 'DateInputWrapper' })<DatePickerPropsType>`
    width: 50%;

    :first-of-type {
        margin-right: 16px;
    }

    .react-datepicker__input-container {
        input {
            border-width: 1px;
            border-style: solid;
            border-color: ${({ isError, isEmpty }): string => isError === true ? input.borderColorTertiary : isEmpty === true ? input.borderColor : input.borderColorSecondary};
        }
    }
    span[role="alert"] {
        display: none;
    }
`;

interface SectionHeaderPropsType {
    isActive: boolean;
    subSection?: boolean;
}

export const SectionHeaderWrapper = styled('div', { label: 'SectionHeaderWrapper' })<SectionHeaderPropsType>`
    display: flex;
    cursor: ${({ isActive }): string => isActive === true ? 'pointer' : 'default'};
    ${({ subSection }): string => subSection === undefined ? '' : 'margin-left: 8px'};
`;

export const SectionHeaderLabel = styled('p', { label: 'SectionHeaderLabel' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.regular};
    font-weight: ${fontWeight.bold};
    margin: 8px 0;
`;

interface ArrowIconPropsType {
    direction: 'down' | 'right';
}

export const ArrowIconBoldWrapper = styled(ArrowUpIcon, { label: 'ArrowIconBoldWrapper' })<ArrowIconPropsType>`
    fill: #000;
    transform: ${({ direction }): string => direction === 'down' ? 'rotate(180deg)' : 'rotate(90deg)'};
    margin-right: 10px;
    cursor: pointer;
`;
